var map = {
	"./3-days-left.svg": "97d9",
	"./4sd.svg": "7d9f",
	"./all-good.svg": "ce92",
	"./amazon.svg": "9a7a",
	"./attachment.svg": "d0d6",
	"./avatar-female.svg": "5322",
	"./avatar-male.svg": "7a16",
	"./clock.svg": "6e22",
	"./dollar-icon-luxliebe.svg": "0749",
	"./dollar-icon.svg": "73c1",
	"./flag-bgr.svg": "8c35",
	"./flags/de.svg": "93c2",
	"./flags/en.svg": "7534",
	"./flags/es.svg": "b45f",
	"./flags/fr.svg": "95e0",
	"./flags/it.svg": "b468",
	"./flags/rs.svg": "41d0",
	"./gold-orb.svg": "75f6",
	"./logo-mobile.svg": "03f2",
	"./logo_white.svg": "10ed",
	"./luxliebe.svg": "3441",
	"./master-card.svg": "8584",
	"./master.svg": "c80e",
	"./new-img/steps-signup-bgr.svg": "02b4",
	"./no-blocked-users.svg": "9cd2",
	"./no-users.svg": "abfb",
	"./no_admirers.svg": "9888",
	"./no_favorites.svg": "5b43",
	"./no_messages.svg": "5540",
	"./no_photos.svg": "c0e9",
	"./no_secret.svg": "f3f3",
	"./no_viewed.svg": "f6e9",
	"./no_visitors.svg": "d560",
	"./not-good.svg": "16dc",
	"./paypal.svg": "38cb",
	"./photo-camera.svg": "50f2",
	"./services/sugardaddy-site-2021.svg": "f497",
	"./ssl.svg": "8518",
	"./sugardaddy.svg": "a5bb",
	"./toastr-img-error.svg": "58fa",
	"./toastr-img-success.svg": "9a3f",
	"./verified-icon.svg": "6893",
	"./verified-members.svg": "a00d",
	"./verified-visa.svg": "783c",
	"./visa-card.svg": "6168",
	"./visa.svg": "6180",
	"./wifi-off.svg": "5635"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "0591";